class PageContentSaveController {

    constructor($rootScope, $state, $stateParams, pageContentService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.pageContentService = pageContentService;
    }

    $onInit() {
        this.activeTab = 'content';
        if (this.type === 'admin'){
            this.pageDetails = this.pageContentService.globalPageDetails(this.$stateParams.page);
        }else{
            this.pageDetails = this.pageContentService.pageDetails(this.$stateParams.page);
        }

        if ( !this.page || Object.keys(this.page).length === 0 ) {
            this.page = {
                'property_id': (this.admin ? 0 : this.$rootScope.currentProperty.id),
                'page': this.pageDetails.slug
            };
        }
    }
}

PageContentSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'pageContentService' ];

export default PageContentSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.save.controller.js